import { apiCallback } from 'api';
import type { ApiCallArgs } from 'api/types';
import type { ApiError } from 'constants/errors';
import type { Price } from 'constants/data-shapes/price';
import type { Quantity } from 'constants/data-shapes/quantity';

interface Promotion {
  category: string;
  description: string;
  endDate: string;
  id: string;
  startDate: string;
}

interface PricedProduct {
  lineNumber: string;
  myWaitroseSaving: Price;
  quantity: Quantity;
  retailPrice: {
    price: Price;
    quantity: Quantity;
  };
  saving: Price;
  totalPrice: Price;
  totalSaving: Price;
  triggeredPromotions: Promotion[];
  untriggeredPromotions: Promotion[];
}

export type Pricing2PricedProductsResponse = Array<{
  date: string;
  pricedProducts: PricedProduct[];
  totals: {
    incentiveSavings: Price;
    myWaitroseSavings: Price;
    orderLevelSavings: Price;
    retailPrice: Price;
    savings: Price;
    totalPrice: Price;
    totalSavings: Price;
  };
}>;

export interface Pricing2Product {
  lineNumber: string;
  quantity: Quantity;
}

interface Incentive {
  code: string;
  threshold: Price;
  value: Price;
}

export type Pricing2PricedProductsRequestBody = {
  products: Pricing2Product[];
  branchId: string;
  dates: string[];
  incentives: Incentive[];
  myWaitrose: boolean;
};

const definition = {
  service: 'pricing2',
  endpoint: 'priced-products',
  verbs: ['post'],
  defaultVersion: 2,
};

const getPricedProducts = (
  args: ApiCallArgs<Pricing2PricedProductsRequestBody>,
): WtrApiCall<Promise<Pricing2PricedProductsResponse | ApiError>> =>
  apiCallback(definition, 'post')(args);

export default {
  post: getPricedProducts,
};
